import { render, staticRenderFns } from "./BranchTransactions.vue?vue&type=template&id=64a33c42&scoped=true"
import script from "./BranchTransactions.vue?vue&type=script&lang=js"
export * from "./BranchTransactions.vue?vue&type=script&lang=js"
import style0 from "./BranchTransactions.vue?vue&type=style&index=0&id=64a33c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a33c42",
  null
  
)

export default component.exports